import React from "react";
import styled from "styled-components";
// Components
import TestimonialSlider from "../Elements/TestimonialSlider";
import TestimonialVideo from "../Elements/TestimonialVideo";

export default function Testimonial() {
  return (
    <div className="lightBg" style={{ padding: "50px 0" }}>
      <div className="container">
        <HeaderInfo>
          <h1 className="font40 extraBold">Testimonials</h1>
          <p className="font13">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut
            <br />
            labore et dolore magna aliquyam erat, sed diam voluptua.
          </p>
        </HeaderInfo>

        {/* Video  Testimonial */}
        <TestimonialVideo />

        <TestimonialSlider />
      </div>
    </div>
  );
}

const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
